export function toSafeKey(string = "", prefix = "") {
  return `${prefix ? prefix + "-" : ""}${string}`
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9\-_]/g, "");
}


// WEBPACK FOOTER //
// ./src/components/components/reportAProblem/_contact-us-rap/_vue/utils/toSafeKey.js